import { render } from "./edit-video-modal.vue?vue&type=template&id=073ab543"
import script from "./edit-video-modal.vue?vue&type=script&lang=js"
export * from "./edit-video-modal.vue?vue&type=script&lang=js"
script.render = render

export default script